import { useState } from 'react'
import { IconButton, Menu } from '@mui/material'
import colors from 'styles/colors'

const OverFlowMenu = ({ children, icon }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          padding: 0
        }}>
        {icon}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        sx={{
          '& .MuiPaper-root': {
            width: 240,
            padding: 1.5,
            border: `1px solid ${colors.Grey200}`,
            borderRadius: 2
          },
          '& .MuiList-root': {
            padding: 0
          },
          '& .MuiMenuItem-root': {
            paddingX: 6,
            paddingY: 5,
            justifyContent: 'flex-start'
          }
        }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right'
        }}>
        {children}
      </Menu>
    </>
  )
}

export default OverFlowMenu
